// import { MRT_ColumnDef, MRT_RowData } from 'material-react-table';
import { Add } from '@mui/icons-material';
import Button from '../../../button/button';
import MaterialTable, { MaterialTableColumnProps } from '../../../material-table/material-table';
import Typography from '../../../typography/typography';
import { Box } from '@mui/material';
import './element.scss';
import { parse, stringify } from 'flatted';
import React, { useCallback } from 'react';
import { useAuth } from '@erpsquad/common/runtime';
import { formatDate } from '../../../../utils/dateFormat';
import Chip from '../../../chip/chip';
import Checkbox from '../../../checkbox/checkbox';
import { MRT_Row } from 'material-react-table';
import _ from 'lodash';
import { formatAmount, getFileName, toFixedWithNumbers } from "../../../../utils/common";
import { getApiConfigSafe } from "../../../../utils/api-config";
import { useTranslation } from 'react-i18next';
import { formatLabel } from '../../../../utils/format-text';
export interface ICellChangeParam {
	value: any,
	data: any,
	col: MaterialTableColumnProps,
	row: MRT_Row<any>,
	name: string,
	uRows: any[]
}

interface IDynamicTable {
	columns: any[];
	rows?: any[];
	position: number;
	label: string;
	disabled?: boolean;
	typeOfField?: string;
	onAddClick?: (name?: string) => void;
	name?: string;
	is_button?: boolean;
	disableTableAddButton?: boolean;
	otherButtons?: React.ReactNode[];
	defaultActionColumnItems?: React.ReactElement[];
	onTableCellChange: ({ value, data, col, row }: ICellChangeParam) => void;
	currencySymbol?: string;
}

const DynamicTable: React.FC<IDynamicTable> = React.memo(({
	columns,
	position,
	label,
	rows = [],
	onAddClick,
	name,
	is_button = true,
	disableTableAddButton,
	otherButtons,
	defaultActionColumnItems,
	onTableCellChange,
	currencySymbol = '',
	...rest
	// disabled
}) => {
	const { t } = useTranslation();
	const { user } = useAuth();
	const cs = currencySymbol || user?.currency_data?.symbol || '';
	const currencyFormat = user?.currency_data?.number_format || '';
	const symbolPosition = user?.currency_data?.position || 'before';
	const isSpar = getApiConfigSafe()?.countryEnv === 'spar';
	const takeCurencyOrPercentage = useCallback((type: string, value: any) => {
		switch (type) {
			case 'Percentage':
				return `${value}%`;
			case 'Fixed Amount':
				return `${cs}${value}`;

			default:
				return value;
		}
	}, [cs]);

	const isCellChangeAFunc = onTableCellChange instanceof Function

	const tableColumns = useCallback(
		(columns: MaterialTableColumnProps[]) => {
			return columns.map((column) => {
				const originalCell = column.Cell;
				return {
					...column,
					header: t(column.header),
					Cell: (cellProps: any) => {
						if (originalCell) {
							return originalCell(cellProps);
						}
						let v = cellProps.renderedCellValue;
						if (column.accessorKey?.endsWith('.items.name')) {
							const prefix = column.accessorKey.replace(/\.name$/, '');
							const item = _.get(cellProps.row.original, prefix);
							if (item?.sku) {
								v = `${item.sku} - ${item.name}`;
							}
						}
						if (isSpar && column.type !== 'currency' && typeof v === 'number' && v && String(v)?.includes('.')) {
							return v = toFixedWithNumbers(v, 4)
						}
						switch (column.type) {
							case 'formattedString':
								v = formatLabel(cellProps.renderedCellValue) || '-';
								break;
							case 'date':
								v = formatDate(
									cellProps.renderedCellValue,
									column.editProperties?.dateFormat || 'DD-MM-YYYY'
								) || '-';
								break;
							case 'currency':
								v = cellProps.renderedCellValue ? `${formatAmount(cellProps.renderedCellValue, currencyFormat, symbolPosition, cs, isSpar ? 4 : undefined)}` : '-';
								break;
							case 'stringOrArray': {
								const type = cellProps.row.original?.promotion_map_data?.type;
								v = Array.isArray(cellProps.renderedCellValue)
									? cellProps.renderedCellValue.map((rcv) => (
										rcv ? <Chip label={takeCurencyOrPercentage(type, rcv)} /> : null
									))
									: takeCurencyOrPercentage(type, cellProps.renderedCellValue);
								break;
							}
							case "checkbox": {
								v = <Checkbox
									checked={Boolean(cellProps.renderedCellValue)}
									onClick={isCellChangeAFunc
										? (e) => onTableCellChange({
											value: e.target.checked,
											data: cellProps.row.original,
											col: column,
											row: cellProps.row,
											name: name,
											uRows: rows
										})
										: undefined
									}
								/>;
								break;
							}
							case "array": {
								v = Array.isArray(cellProps.renderedCellValue) && cellProps.renderedCellValue.length ?
									<Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', flexWrap: 'wrap' }}>
										{cellProps.renderedCellValue.map(r => (<Chip type='normal' label={_.get(r, column?.valueGet, '')} active />))}
									</Box>
									: '-';
								break;
							}
							case "file": {
								v = getFileName(cellProps.renderedCellValue) || '-';
								break;
							}
						}

						return v;
					}
				};
			});
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[cs, takeCurencyOrPercentage, currencySymbol, rows]
	);
	return (
		<Box data-position={position}>
			<Typography
				type='s5'
				weight='medium'
				color='theme.secondary.800'
				data-position={position}
				sx={{ mb: 0.5 }}>
				{t(label)}
			</Typography>
			<Box /* sx={disabled ? { pointerEvents: 'none' } : {}} */>
				<MaterialTable
					columnOrder={['mrt-row-select']}
					// rows={parse(stringify(rows))}
					rows={rows}
					columns={tableColumns(columns ? columns.map((col: any) => ({ ...col })) : [])}
					totalPages={20}
					paginationModel={{ pageNo: 1, limit: 20 }}
					enableEditing={false}
					enableColumnDragging={false}
					enableBottomToolbar={false}
					defaultActionColumnItems={defaultActionColumnItems}
					{...rest}
				/>
				{is_button && !disableTableAddButton && (
					<Box
						sx={{
							display: 'flex',
							width: '100%',
							justifyContent: 'space-between',
							mt: 1
						}}>
						<Button
							variant='outlined'
							onClick={() => onAddClick?.(name)}
							startIcon={<Add />}
							className='table--AddButton'>
							Add
						</Button>
						{Boolean(otherButtons?.length) && otherButtons}
					</Box>
				)}
			</Box>
		</Box>
	);
});

export default DynamicTable;
